import React, { Component } from 'react';

class SearchBox extends Component {
  render() {
    return (
      <div className="searchbox__wrapper">
      	<input
          type="text"
          className="searchbox"
          value={this.props.value}
          onChange={this.props.onChange}
          placeholder={this.props.placeholder} />
      </div>
    );
  }
}

export default SearchBox;


// WEBPACK FOOTER //
// ./src/modules/common/SearchBox.js